/**
 * Creates a function that debounces calls to the specified function. Calling this function repeatedly will
 * only result in a call to the function after `timeout` milliseconds of inactivity.
 * @param func The function to call
 * @param timeout The debounce timeout, in milliseconds
 * @returns The debounced function
*/
export function createDebouncingFunction<TArgs extends unknown[]>(
    func: (...args: TArgs) => unknown,
    timeout: number
): (...args: TArgs) => void
{
    let timeoutID: ReturnType<typeof setTimeout> | undefined = undefined;

    return (...args: TArgs) =>
    {
        clearTimeout(timeoutID);

        timeoutID = setTimeout(() => func(...args), timeout, ...args);
    };
}
